import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TopicMenu from "../menu/TopicMenu";
import NavBar from "../navbar/Navbar";
import SideBar from "../sidebar/Sidebar";
import {Alert, App, Layout} from "antd";
import Plati from "../content/Plati";
import Indice from "../content/Indice";
import { ConfigProvider } from "antd";
import Misc from "../content/Misc";
import Users from "../content/Users";
import Backups from "../content/Backups";
import WorkingMonth from "../content/WorkingMonth";
import axios from "axios";
import {API_URL, lastDoc} from "../../constants";
// import LUC from "../content/LUC";

const Main = () => {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.user.currentUser);
  const topics = [
    { name: "Indici", content: <Indice /> },
    { name: "Plati", content: <Plati /> },
    { name: "Documente diverse", content: <Misc /> },
    { name: "Utilizatori", content: <Users /> },
    { name: "Backup-uri", content: <Backups /> },
    { name: "Luna de lucru", content: <WorkingMonth /> },
    // { name: "LUC", content: <LUC /> },
  ];
  const [contentIndex, setContentIndex] = useState(0);
  const [selectedKey, setSelectedKey] = useState("0");
  const [showAlrert, setShowAlrert] = useState(false);
  const getBlockStatusClientIndici = async () => {
    try {
      const res = await axios.get(
          API_URL + "user/gestionar/client/blockageStatus"
      );
      const res2 = await lastDoc();
      if(res.data.blocked) {
        let idiceObject = res2.data.find(item => item.type === "indice");
        //Add code here
        if (idiceObject) {
          const createdAt = new Date(idiceObject.createdAt);
          const now = new Date();

          const isSameMonth =
              createdAt.getFullYear() === now.getFullYear() &&
              createdAt.getMonth() === now.getMonth();

          if (isSameMonth) {
            setShowAlrert(true)
          }
        }
      }
      console.log(res, res2)
    } catch (error) {
      console.log({ error });
    }
  };
  useEffect(() => {
    setSelectedKey(localStorage.getItem("tab"));
    setContentIndex(+localStorage.getItem("tab"));
    getBlockStatusClientIndici()
  }, []);

  useEffect(() => {
    if (currentUser?.role !== "admin") {
      navigate("/login");
      sessionStorage.clear();
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentUser?.role === "admin") {
      const parsedKey = parseInt(selectedKey);
      let nav = "indice";
      switch (parsedKey) {
        case 0:
          nav = "indice";
          break;
        case 1:
          nav = "plati";
          break;
        case 2:
          nav = "docs";
          break;
        case 3:
          nav = "users";
          break;
        case 4:
          nav = "backups";
          break;
        case 5:
          nav = "luna";
          break;
        default:
          break;
      }
      navigate(`/${nav}`);
    }
  }, [selectedKey, currentUser]);

  const changeSelectedKey = (event) => {
    const key = event.key;
    setSelectedKey(key);
    setContentIndex(+key);
    localStorage.setItem("tab", key);
  };
  const Menu = (
    <TopicMenu
      topics={topics}
      selectedKey={selectedKey}
      changeSelectedKey={changeSelectedKey}
    />
  );

  const token = {
    colorPrimary: "#f28737",
  };

  return (
    <div className="App">
      <ConfigProvider
        theme={{ token, components: { Button: { dangerColor: "#FF0000" } } }}
      >
        <App>
          <NavBar menu={Menu} />
          <Layout>
            <SideBar menu={Menu} />
            <Layout.Content className="content">

              {/*{showAlrert && (<Alert message="În cursul acestei luni a fost încărcat fișierul cu indici, iar accesul la introducerea indicilor de consum pentru consumatorii casnici este restricționat. Vă rugăm respectuos să activați drepturile necesare în vederea transmiterii indicilor de către consumatorii casnici." type="error" style={{marginBottom: "10px"}} />)}*/}
              {showAlrert && (<Alert
                  description={
                    <>
                      Fișierul cu indicii a fost încărcat cu succes. Puteți activa funcționalitatea de introducere a indicilor pe platforma{" "}
                      <b><a href={"https://invoicer.md"} target={"_blank"}>invoicer.md</a></b> și debloca opțiunea de modificare a acestora în aplicația gestionarului.
                    </>
                  }
                  type="error" style={{marginBottom: "10px"}} />)}
              {topics[contentIndex]?.content}
            </Layout.Content>
          </Layout>
        </App>
      </ConfigProvider>
    </div>
  );
};

export default Main;
